import React from 'react';

import ClientOrganizationsContent from './ClientOrganizationsContent';
import MemberMiniMenu from '../members/menus/MemberMiniMenu';

const ClientOrganizationsPage = () => {
    return (
        <MemberMiniMenu>
            <ClientOrganizationsContent />
        </MemberMiniMenu>
    )
};

export default ClientOrganizationsPage;